const util = {};
var getRandomLocation = function(latitude, longitude, radiusInMeters) {
  const r = 100 / 111300, // = 100 meters
    y0 = latitude,
    x0 = longitude,
    u = Math.random(),
    v = Math.random(),
    w = r * Math.sqrt(u),
    t = 2 * Math.PI * v,
    x = w * Math.cos(t),
    y1 = w * Math.sin(t),
    x1 = x / Math.cos(y0);

  let newY = y0 + y1;
  let newX = x0 + x1;

  // Offset position in decimal degrees.
  return {
    lat: newY,
    lng: newX
  };
};
function isMobile() {
  try {
    if (
      /Android|webOS|iPhone|iPad|iPod|pocket|psp|kindle|avantgo|blazer|midori|Tablet|Palm|maemo|plucker|phone|BlackBerry|symbian|IEMobile|mobile|ZuneWP7|Windows Phone|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      return true;
    }
    return false;
  } catch (e) {
    console.log("Error in isMobile");
    return false;
  }
}

function isFirefox() {
  let f = navigator.userAgent.search("Firefox");
  if (f > -1) {
    return true;
  } else {
    return false;
  }
}

function isIE11(){
  var ua = window.navigator.userAgent;
  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

}
util.getRandomLocation = getRandomLocation;
util.isMobile = isMobile;
util.isFirefox = isFirefox;
util.isIE11 = isIE11;

export default util;
